import { useEffect, useState } from 'react'
import { Box, Grid, makeStyles, Paper } from '@material-ui/core'
import Api from '../../../Apis/api.service'
import ProcessCard from '../../../components/common/Cards/ProcessCard'
import { AskAccountingQuestion } from '../../ask_accounting_question'
import { Button } from 'react-admin'

const useStyles = makeStyles({
  button: {
    padding: '8px !important',
    background: 'white !important',
    color: '#143A5F !important',
    border: '1px solid #143A5F !important',
    borderRadius: '5px !important',
    fontSize: '0.8125rem !important',
    '&:hover': {
      background: '#143A5F !important',
      color: '#ffffff !important',
    },
    '&:disabled': {
      color: '#66666699 !important',
      background: '#e6e5e5a8 !important',
      borderColor: '#e4e6ef !important',
    },
  },
})

export const ExtCoproTicketAccountingList = (props) => {
  const copro_id = props.copro?.id
  const coproprietaire_id = props?.coproprietaire?.id
  const copros_monday_internal_id = props?.copro?.copros_monday_internal_id
  const classes = useStyles()

  const [data, setData] = useState([])
  const [
    showDialogAccountingTicketCreate,
    setShowDialogAccountingTicketCreate,
  ] = useState(false)
  const toggleDialogAccountingTicketCreate = () =>
    setShowDialogAccountingTicketCreate(!showDialogAccountingTicketCreate)
  const fetchData = async () => {
    const res = await Api.copros.getAccountingTicket(
      copros_monday_internal_id,
      { coproprietaire_id }
    )
    if (res.status == 200 && res.data.ok) {
      setData(res.data.data)
    }
  }
  useEffect(() => {
    fetchData()
  }, [copros_monday_internal_id, coproprietaire_id])
  return (
    <>
      <Grid container style={{ alignItems: 'center' }}>
        <Box component={Paper} sx={{ width: '100%' }}>
          {coproprietaire_id ? (
            <Box
              sx={{
                flex: 1,
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'end',
                margin: '10px',
              }}
            >
              <Button
                color="primary"
                size="large"
                variant="contained"
                onClick={toggleDialogAccountingTicketCreate}
                disableElevation
                className={classes.button}
              >
                J’ai une question Comptable
              </Button>

              <AskAccountingQuestion
                {...props}
                copro_id={props.copro.copros_monday_internal_id}
                copro_internal_id={props.copro.copro_internal_id}
                coproprietaire_id={props.coproprietaire.id}
                show={showDialogAccountingTicketCreate}
                setShow={setShowDialogAccountingTicketCreate}
                refresh={() => {
                  fetchData()
                }}
              />
            </Box>
          ) : null}
          <ProcessCard
            coproprietaire={props.coproprietaire}
            tickets={data}
            processName={'Questions Comptables'}
            linkable_type={'tickets'}
          />
        </Box>
      </Grid>
    </>
  )
}

export default ExtCoproTicketAccountingList
